import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
import { useState } from "react";
import { queryClient } from "../../router/ReturnOrderRouter";

const EditReturnOrderComponent = loadable(
  () => import("../../components/ReturnOrders/SwitchTab")
);

const EditReturnOrder = () => {
  const { id } = useParams();
  const [defaultValue, setDefaultValue] = useState(null);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`return-order-${id}`],
    url: `${APIS.RTV_ORDER}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`return-order-${id}`, "return-order"],
    navigateURL: "",
  });
  const { data: gridData, isLoading: isStatusDataLoading } = useGetHook({
    queryKey: [`rtv-status`],
    url: `${APIS.RTV_STATUS}`,
    params: {},
  });

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } =
    usePatchHook({
      queryKey: [`return-order-${id}`, "return-order"],
      navigateURL: "",
    });

  const { mutateAsync: addVehicle, isPostLoading: isVehicleLoading } =
    usePostHook({
      queryKey: ["vehicle"],
      navigateURL: "",
    });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });

  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
      mobile_number: `+977${values?.mobile_number}`,
    };
    try {
      await addDriver({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const handleAddVehicle = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE}`;
    let formData = {
      ...values,
      emergency_contact_number: `+977${values?.emergency_contact_number}`,
      insurance_company_contact_number: `+977${values?.insurance_company_contact_number}`,
      samiti_contact_number: `+977${values?.samiti_contact_number}`,
    };
    try {
      await addVehicle({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.RTV_ORDER}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["return-order-items"],
    navigateURL: "",
  });
  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-return-order-items"],
  });

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.RTV_ORDER}${id}/toggle-is-active/`;

    try {
      await toggleMarkAsDone({ url, setError });
      await refetch();
    } catch (err) {
      console.log(err);
    }
  };

  const handlecheckConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.RTV_ORDER}receive-order/`;
    let formData = {
      tracking_number: consignmentId,
    };
    try {
      await checkConsignmentsMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const handleAttachConsignment = async (
    consignmentId: string,
    statusId: any,
    setError: any
  ) => {
    const url = `${APIS.RTV_ORDER_ITEMS}`;
    let formData = {
      status_id: statusId,
      rtv_order: id,
      tracking_number: consignmentId,
    };

    try {
      let res = await attachConsignmentMutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.log(err);
    }
  };
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handlePrint = async () => {
    const url = `${APIS.RTV_ORDER}${id}/print-pdf-rtv/`;
    let formData = {};
    try {
      await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };
  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Assign RTV/Return
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditReturnOrderComponent
          isLoading={isPatchLoading}
          data={data}
          handleEdit={handleEdit}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handlecheckConsignments={handlecheckConsignments}
          handleAttachConsignment={handleAttachConsignment}
          handleToggleMarkAsDone={handleToggleMarkAsDone}
          handleAddVehicle={handleAddVehicle}
          gridData={gridData}
          id={id}
          isVehicleLoading={isVehicleLoading}
          isPrintLoading={isPrintLoading}
          handleStatusChange={handleStatusChange}
          handleAddDriver={handleAddDriver}
          handlePrint={handlePrint}
          isDriverLoading={isDriverLoading}
        />
      )}
    </div>
  );
};

export default EditReturnOrder;
